import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Upload, UploadProps } from "antd";
import classNames from "classnames";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";
import { Transforms } from "slate";
import { useSlate } from "slate-react";

export const ImageButton = ({ disabled }: { disabled?: boolean }) => {
  const editor = useSlate();
  const { t } = useTranslation(I18N_NS.RICH_EDITOR);

  const handleAddImage: UploadProps["customRequest"] = async (options) => {
    try {
      const file = options.file;
      const base64: string = await new Promise((res, rej) => {
        const reader = new FileReader();
        reader.readAsDataURL(file as File);
        reader.onload = () => res(reader.result.toString());
        reader.onerror = rej;
      });
      Transforms.insertNodes(editor, { type: "img", src: base64, alt: options.filename, children: [{ text: "" }] });
    } catch (error) {
      throw error;
    }
  };

  return (
    <Upload accept="image/*" customRequest={handleAddImage} disabled={disabled} showUploadList={false}>
      <div title={t("Image")} className={classNames(["slate--mark-btn", { ["mark-disabled"]: disabled }])}>
        <FontAwesomeIcon icon={["far", "image"]} fixedWidth />
      </div>
    </Upload>
  );
};
